export const SchemeForm = () => {

  const $form = $('.js-scheme__form')

  if ( !$form.length ) return

  const $jointRadio = $('.js-scheme__formRadio--joint')
  const $singleRadio = $('.js-scheme__formRadio--single')
  const $partnerDetails = $('.js-scheme__formPartnerDetails')
  const $priceIdCheckbox = $('#price_id_checkbox');


  if ( $jointRadio.length ) {

    $jointRadio.on('change', function() {
      if ( $(this).is(':checked') ) {
        $partnerDetails.removeClass('is-hidden')
        $partnerDetails.find('input').prop('required', true)
      }
    })

    $singleRadio.on('change', function() {
      if ( $(this).is(':checked') ) {
        $partnerDetails.addClass('is-hidden')
        $partnerDetails.find('input').prop('required', false)
      }
    })

  }

  if ($priceIdCheckbox.length) {

    $('#membership_subtype_standard').on('change', function() {
      if (this.checked) {
        $priceIdCheckbox.val($(this).data('price-id'));
      }
    });
  
    $('#membership_subtype_print_pack').on('change', function() {
      if (this.checked) {
        $priceIdCheckbox.val($(this).data('price-id'));
      }
    });

  }
  
}
